'use client'

import { useEffect } from 'react'
import useCompaniesQueryV1 from '@/api/admin/companies/useCompaniesQueryV1'
import useCompanyQueryV1 from '@/api/core/companies/useCompanyQueryV1'
import { useUserStore } from '@/stores/user-store'

export const useCompanyLoader = () => {
  const companyIdFromStore = useUserStore((state) => state.companyId)
  const setCompany = useUserStore((state) => state.setCompany)
  const isAdmin = useUserStore((state) => state.isAdmin)
  const setError = useUserStore((state) => state.setError)

  const { data: allCompanies, error: allCompaniesError } = useCompaniesQueryV1(isAdmin)
  const { data: companyData, error: companyError } = useCompanyQueryV1(companyIdFromStore, !!companyIdFromStore)

  useEffect(() => {
    if (allCompaniesError && companyError) {
      console.error('[useCompanyLoader] Error loading company:', companyError)
      setCompany(undefined)
      setError(allCompaniesError || companyError)
    } else {
      if (companyData) {
        setCompany(companyData)
      } else {
        if (isAdmin) {
          const firstCompany = allCompanies && allCompanies.length > 0 ? allCompanies[0] : undefined
          setCompany(firstCompany)
        }
      }
    }
  }, [companyData, companyError, isAdmin, allCompanies, setCompany, setError, allCompaniesError])

  return {}
}
